export default {
  methods: {

    draw_Forms() {

      this.canvasForms = this.svg
      .append('g')
      .attr('transform', `translate(0,0)`)
      .style('font-family', 'roboto')
      .attr('cursor', 'default')

      // this.canvasForms
      // .append('image')
      // .attr('cursor', 'pointer')
      // .attr('transform', `translate(0, 0)`).attr('width', 760)
      // .attr('xlink:href', this.HOST + `/woodside_01.jpg`)
      // .attr('opacity', .4)

      let title = this.canvasForms
      .append('g')
      .attr('transform', `translate(${this.overall.x}, ${30})`)

      title
      .append('text')
      .attr('x', 0).attr('y', -(0) + 18*0.75)
      .attr('fill', '#44A9DF').attr('font-size', 18)
      .attr('text-anchor', 'middle')
      .text(this.overall.name)


      // let btn = this.canvasForms
      // .append('g')
      // .attr('transform', `translate(${630}, ${40})`)

      // btn
      // .append('circle')
      // .attr('cx', -30).attr('cy', 0)
      // .attr('r', 8)
      // .attr('fill',  `url(#${this.localId}_${this.overall.color}_V2)`)

      // this.circle.phase.forEach((d,i)=>{
      //    btn
      //   .append('circle')
      //   .attr('cx', i*30).attr('cy', 0)
      //   .attr('r', 8)
      //   .attr('fill', d.color)
      // })

      this.draw_Overall() // ----->
      this.draw_EPCs() // ----->
      this.draw_Area() // ----->


      if (this.sundries) {
        let sunData = this.JQueries.sundriesConfig && this.JQueries.sundriesConfig.SQL ? this.Queries[this.JQueries.sundriesConfig.SQL][0] : this.DataItems[0]
        if(this.sundries.length > 0) this.gmx_Sundries(this.svg, this.sundries, sunData, this.JQueries.sundriesConfig.server)
      }
    },




    
  }
}